import request from '@/utils/request'
export const getUnReadMsgCount = (id) => {
  return request.get(`/contactmsgs/${id}`)
}
export const getMsg = () => { // 获取所有未读消息以及已读消息的列表
  return request.post('/contactmsgs/my')
}
export const changeMsgToRead = (senderId, createTime) => { // 获取所有未读消息以及已读消息的列表
  return request.put(`/contactmsgs?senderId=${senderId}&createTime=${createTime}`)
}
export const getMoreMsg = (contactMsgQuery) => { // 获取所有未读消息以及已读消息的列表
  return request.post('/contactmsgs/more', contactMsgQuery)
}
export const addMsg = (contactMsgDto) => { // 添加消息
  return request.post('/contactmsgs/add', contactMsgDto)
}
